import {Button, Flex} from 'antd';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {ReactComponent as UpgradePlanWhiteIcon} from '../../../assets/icons/UpgradePlanWhiteIcon.svg';
import {Routes} from '../../../constants/Routes';
import {subscriptionPlanTypes} from '../../../constants/subscriptionConstants';

interface CurrentPlanInfoCompProps {
  activePlan: string;
}

const CurrentPlanInfoComp: React.FC<CurrentPlanInfoCompProps> = ({
  activePlan
}) => {
  const navigate = useNavigate();

  return (
    <div className="mainCurrentPlanInfoContainerMain">
      <Flex
        className="mainCurrentPlanInfoContainer"
        align="center"
        vertical
        gap={10}
      >
        <Button
          type="primary"
          className="upgradePlanWhite"
          onClick={() => {
            navigate(Routes.PRICING_DETAILS);
          }}
        >
          {activePlan === subscriptionPlanTypes.ENTERPRISE ? null : (
            <UpgradePlanWhiteIcon />
          )}

          {activePlan === subscriptionPlanTypes.ENTERPRISE
            ? 'View Plan'
            : 'Upgrade Plan'}
        </Button>
      </Flex>
    </div>
  );
};

export default CurrentPlanInfoComp;
